// import React, { useEffect, useState } from "react";
// import { X } from "lucide-react";
// import { useForm } from "react-hook-form";
// import { z } from "zod";
// import { zodResolver } from "@hookform/resolvers/zod";
// import { useUpdateSubs } from "../hooks/useUpdateSubs";

// // Validation Schema
// const subscriptionEditSchema = z.object({
//     nameEnglish: z.string().min(3, "English name is required"),
//     nameHindi: z.string().optional(),
//     nameMarwari: z.string().optional(),
//     descriptionEnglish: z.string().min(10, "English description is required"),
//     descriptionHindi: z.string().optional(),
//     descriptionMarwari: z.string().optional(),
//     // basePrice: z.number().min(0, "Base price must be positive"),
//     // discountedPrice: z.number().min(0, "Discounted price must be positive"),
//     // currency: z.string().min(1, "Currency is required"),
//     // duration: z.number().min(1, "Duration must be positive"),
//     // durationType: z.enum(["days", "weeks", "months", "years"]),
//     // status: z.enum(["active", "inactive", "draft"]),
//     // features: z.array(z.string()).min(1, "At least one feature is required"),
//     // maxUsers: z.number().min(1, "Maximum users must be positive"),
//     // trialDays: z.number().min(0, "Trial days must be positive"),
//     // isPopular: z.boolean(),
// });

// // Status options
// const subscriptionStatuses = [
//     { value: "active", label: "Active", color: "text-green-400" },
//     { value: "inactive", label: "Inactive", color: "text-red-400" },
//     { value: "draft", label: "Draft", color: "text-yellow-400" }
// ];

// export const EditSubscriptionModal = ({ isEditModalOpen, setIsEditModalOpen, subscription }) => {
//     const { mutate: updateSubscription, isPending } = useUpdateSubs();
//     const [features, setFeatures] = useState([]);
    
//     const {
//         register,
//         handleSubmit,
//         reset,
//         setValue,
//         watch,
//         formState: { errors },
//     } = useForm({
//         resolver: zodResolver(subscriptionEditSchema),
//         defaultValues: {
//             nameEnglish: "",
//             nameHindi: "",
//             nameMarwari: "",
//             descriptionEnglish: "",
//             descriptionHindi: "",
//             descriptionMarwari: "",
//             basePrice: 0,
//             discountedPrice: 0,
//             currency: "INR",
//             duration: 1,
//             durationType: "months",
//             status: "draft",
//             features: [""],
//             maxUsers: 1,
//             trialDays: 0,
//             isPopular: false,
//         },
//     });

//     /* Load Data */
//     useEffect(() => {
//         if (subscription) {
//             const subscriptionData = {
//                 nameEnglish: subscription.name?.english || "",
//                 nameHindi: subscription.name?.hindi || "",
//                 nameMarwari: subscription.name?.marwari || "",
//                 descriptionEnglish: subscription.description?.english || "",
//                 descriptionHindi: subscription.description?.hindi || "",
//                 descriptionMarwari: subscription.description?.marwari || "",
//                 basePrice: subscription?.basePrice || 0,
//                 discountedPrice: subscription?.discountedPrice || 0,
//                 currency: subscription.currency || "INR",
//                 duration: subscription?.duration || 1,
//                 durationType: subscription.durationType || "months",
//                 status: subscription.status || "draft",
//                 features: subscription.features || [""],
//                 maxUsers: subscription.maxUsers || 1,
//                 trialDays: subscription.trialDays || 0,
//                 isPopular: subscription.isPopular || false,
//             };

//             reset(subscriptionData);
//             setFeatures(subscription.features || [""]);
//         }
//     }, [subscription, reset]);

//     const addFeature = () => {
//         const updatedFeatures = [...features, ""];
//         setFeatures(updatedFeatures);
//         setValue("features", updatedFeatures);
//     };

//     const removeFeature = (index) => {
//         const updatedFeatures = features.filter((_, i) => i !== index);
//         setFeatures(updatedFeatures);
//         setValue("features", updatedFeatures);
//     };

//     const updateFeature = (index, value) => {
//         const updatedFeatures = [...features];
//         updatedFeatures[index] = value;
//         setFeatures(updatedFeatures);
//         setValue("features", updatedFeatures);
//     };

//     const onSubmit = (data) => {
//         const subscriptionData = {
//             name: {
//                 english: data.nameEnglish,
//                 hindi: data.nameHindi,
//                 marwari: data.nameMarwari,
//             },
//             description: {
//                 english: data.descriptionEnglish,
//                 hindi: data.descriptionHindi,
//                 marwari: data.descriptionMarwari,
//             },
//             basePrice: Number(data.basePrice),
//             discountedPrice: Number(data.discountedPrice),
//             currency: data.currency,
//             duration: Number(data.duration),
//             durationType: data.durationType,
//             status: data.status,
//             // features: data.features.filter(f => f.trim()),
//             maxUsers: Number(data.maxUsers),
//             trialDays: Number(data.trialDays),
//             isPopular: data.isPopular,
//         };

//         updateSubscription(
//             {
//                 subscriptionId: subscription._id,
//                 subscriptionData,
//             },
//             {
//                 onSuccess: () => {
//                     reset();
//                     setFeatures([""]);
//                     setIsEditModalOpen(false);
//                 },
//             }
//         );
//     };

//     if (!isEditModalOpen) return null;

//     return (
//         <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
//             <div className="bg-[#111827] w-full max-w-4xl rounded-xl shadow-xl border border-gray-700 p-6 max-h-[90vh] overflow-y-auto">
                
//                 {/* Header */}
//                 <div className="flex justify-between items-center mb-6">
//                     <h2 className="text-xl font-semibold text-white">Edit Subscription Plan</h2>
//                     <button onClick={() => setIsEditModalOpen(false)} className="text-gray-400 hover:text-white">
//                         <X size={22} />
//                     </button>
//                 </div>

//                 {/* Form */}
//                 <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">

//                     {/* Names Section */}
//                     <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                         <div>
//                             <label className="block text-sm text-gray-300 mb-1">Plan Name (English) *</label>
//                             <input
//                                 {...register("nameEnglish")}
//                                 className="w-full bg-gray-800 border border-gray-700 text-white rounded-md px-3 py-2"
//                                 placeholder="Premium Plan"
//                             />
//                             {errors.nameEnglish && (
//                                 <p className="text-red-500 text-xs mt-1">{errors.nameEnglish.message}</p>
//                             )}
//                         </div>

//                         <div>
//                             <label className="block text-sm text-gray-300 mb-1">Plan Name (Hindi)</label>
//                             <input
//                                 {...register("nameHindi")}
//                                 className="w-full bg-gray-800 border border-gray-700 text-white rounded-md px-3 py-2"
//                                 placeholder="प्रीमियम योजना"
//                             />
//                             {errors.nameHindi && (
//                                 <p className="text-red-500 text-xs mt-1">{errors.nameHindi.message}</p>
//                             )}
//                         </div>

//                         <div>
//                             <label className="block text-sm text-gray-300 mb-1">Plan Name (Marwari)</label>
//                             <input
//                                 {...register("nameMarwari")}
//                                 className="w-full bg-gray-800 border border-gray-700 text-white rounded-md px-3 py-2"
//                                 placeholder="प्रीमियम योजना"
//                             />
//                             {errors.nameMarwari && (
//                                 <p className="text-red-500 text-xs mt-1">{errors.nameMarwari.message}</p>
//                             )}
//                         </div>
//                     </div>

//                     {/* Descriptions Section */}
//                     <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                         <div>
//                             <label className="block text-sm text-gray-300 mb-1">Description (English) *</label>
//                             <textarea
//                                 {...register("descriptionEnglish")}
//                                 className="w-full bg-gray-800 border border-gray-700 text-white rounded-md px-3 py-2 h-20"
//                                 placeholder="Full access to all features"
//                             />
//                             {errors.descriptionEnglish && (
//                                 <p className="text-red-500 text-xs mt-1">{errors.descriptionEnglish.message}</p>
//                             )}
//                         </div>

//                         <div>
//                             <label className="block text-sm text-gray-300 mb-1">Description (Hindi)</label>
//                             <textarea
//                                 {...register("descriptionHindi")}
//                                 className="w-full bg-gray-800 border border-gray-700 text-white rounded-md px-3 py-2 h-20"
//                                 placeholder="सभी सुविधाओं तक पूर्ण पहुंच"
//                             />
//                             {errors.descriptionHindi && (
//                                 <p className="text-red-500 text-xs mt-1">{errors.descriptionHindi.message}</p>
//                             )}
//                         </div>

//                         <div>
//                             <label className="block text-sm text-gray-300 mb-1">Description (Marwari)</label>
//                             <textarea
//                                 {...register("descriptionMarwari")}
//                                 className="w-full bg-gray-800 border border-gray-700 text-white rounded-md px-3 py-2 h-20"
//                                 placeholder="सगळी सुविधा"
//                             />
//                             {errors.descriptionMarwari && (
//                                 <p className="text-red-500 text-xs mt-1">{errors.descriptionMarwari.message}</p>
//                             )}
//                         </div>
//                     </div>

//                     {/* Pricing & Status Section */}
//                     {/* <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//                         <div>
//                             <label className="block text-sm text-gray-300 mb-1">Base Price *</label>
//                             <input
//                                 type="number"
//                                 {...register("basePrice", { valueAsNumber: true })}
//                                 className="w-full bg-gray-800 border border-gray-700 text-white rounded-md px-3 py-2"
//                                 placeholder="499"
//                             />
//                             {errors.basePrice && (
//                                 <p className="text-red-500 text-xs mt-1">{errors.basePrice.message}</p>
//                             )}
//                         </div>

//                         <div>
//                             <label className="block text-sm text-gray-300 mb-1">Discounted Price *</label>
//                             <input
//                                 type="number"
//                                 {...register("discountedPrice", { valueAsNumber: true })}
//                                 className="w-full bg-gray-800 border border-gray-700 text-white rounded-md px-3 py-2"
//                                 placeholder="299"
//                             />
//                             {errors.discountedPrice && (
//                                 <p className="text-red-500 text-xs mt-1">{errors.discountedPrice.message}</p>
//                             )}
//                         </div>

//                         <div>
//                             <label className="block text-sm text-gray-300 mb-1">Currency *</label>
//                             <select
//                                 {...register("currency")}
//                                 className="w-full bg-gray-800 border border-gray-700 text-white rounded-md px-3 py-2"
//                             >
//                                 <option value="INR">INR</option>
//                                 <option value="USD">USD</option>
//                                 <option value="EUR">EUR</option>
//                             </select>
//                         </div>

//                         <div>
//                             <label className="block text-sm text-gray-300 mb-1">Status *</label>
//                             <select
//                                 {...register("status")}
//                                 className="w-full bg-gray-800 border border-gray-700 text-white rounded-md px-3 py-2"
//                             >
//                                 {subscriptionStatuses.map((status) => (
//                                     <option key={status.value} value={status.value}>
//                                         {status.label}
//                                     </option>
//                                 ))}
//                             </select>
//                             {errors.status && (
//                                 <p className="text-red-500 text-xs mt-1">{errors.status.message}</p>
//                             )}
//                         </div>
//                     </div> */}

//                     {/* Duration Section */}
//                     {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                         <div>
//                             <label className="block text-sm text-gray-300 mb-1">Duration *</label>
//                             <input
//                                 type="number"
//                                 {...register("duration", { valueAsNumber: true })}
//                                 className="w-full bg-gray-800 border border-gray-700 text-white rounded-md px-3 py-2"
//                                 placeholder="3"
//                             />
//                             {errors.duration && (
//                                 <p className="text-red-500 text-xs mt-1">{errors.duration.message}</p>
//                             )}
//                         </div>

//                         <div>
//                             <label className="block text-sm text-gray-300 mb-1">Duration Type *</label>
//                             <select
//                                 {...register("durationType")}
//                                 className="w-full bg-gray-800 border border-gray-700 text-white rounded-md px-3 py-2"
//                             >
//                                 <option value="days">Days</option>
//                                 <option value="weeks">Weeks</option>
//                                 <option value="months">Months</option>
//                                 <option value="years">Years</option>
//                             </select>
//                             {errors.durationType && (
//                                 <p className="text-red-500 text-xs mt-1">{errors.durationType.message}</p>
//                             )}
//                         </div>

//                         <div>
//                             <label className="block text-sm text-gray-300 mb-1">Max Users *</label>
//                             <input
//                                 type="number"
//                                 {...register("maxUsers", { valueAsNumber: true })}
//                                 className="w-full bg-gray-800 border border-gray-700 text-white rounded-md px-3 py-2"
//                                 placeholder="5"
//                             />
//                             {errors.maxUsers && (
//                                 <p className="text-red-500 text-xs mt-1">{errors.maxUsers.message}</p>
//                             )}
//                         </div>
//                     </div> */}

//                     {/* Additional Settings */}
//                     {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                         <div>
//                             <label className="block text-sm text-gray-300 mb-1">Trial Days</label>
//                             <input
//                                 type="number"
//                                 {...register("trialDays", { valueAsNumber: true })}
//                                 className="w-full bg-gray-800 border border-gray-700 text-white rounded-md px-3 py-2"
//                                 placeholder="7"
//                             />
//                         </div>

//                         <div className="flex items-center gap-2 pt-6">
//                             <input type="checkbox" {...register("isPopular")} />
//                             <span className="text-sm text-gray-300">Mark as Popular Plan</span>
//                         </div>
//                     </div> */}

//                     {/* Features Section */}
//                     {/* <div>
//                         <div className="flex items-center justify-between mb-3">
//                             <div>
//                                 <label className="block text-sm text-gray-300 mb-1">Features *</label>
//                                 <p className="text-xs text-gray-500">Manage subscription features</p>
//                             </div>
//                             <button
//                                 type="button"
//                                 onClick={addFeature}
//                                 className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm"
//                             >
//                                 Add Feature
//                             </button>
//                         </div>
//                         <div className="space-y-2">
//                             {features.map((feature, index) => (
//                                 <div key={index} className="flex gap-2">
//                                     <input
//                                         type="text"
//                                         value={feature}
//                                         onChange={(e) => updateFeature(index, e.target.value)}
//                                         className="flex-1 bg-gray-800 border border-gray-700 text-white rounded-md px-3 py-2"
//                                         placeholder="Unlimited Projects"
//                                     />
//                                     {features.length > 1 && (
//                                         <button
//                                             type="button"
//                                             onClick={() => removeFeature(index)}
//                                             className="text-red-500 hover:text-red-400 px-2"
//                                         >
//                                             Remove
//                                         </button>
//                                     )}
//                                 </div>
//                             ))}
//                         </div>
//                         {errors.features && (
//                             <p className="text-red-500 text-xs mt-1">{errors.features.message}</p>
//                         )}
//                     </div> */}

//                     {/* Buttons */}
//                     <div className="flex justify-end gap-4 pt-4 border-t border-gray-700">
//                         <button
//                             type="button"
//                             className="text-gray-300 hover:text-white"
//                             onClick={() => setIsEditModalOpen(false)}
//                         >
//                             Cancel
//                         </button>

//                         <button
//                             type="submit"
//                             disabled={isPending}
//                             className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md"
//                         >
//                             {isPending ? "Updating..." : "Update Subscription"}
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };
import React, { useEffect } from "react";
import { X } from "lucide-react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useUpdateSubs } from "../hooks/useUpdateSubs";

const subscriptionEditSchema = z.object({
    nameEnglish: z.string().min(3, "English name is required"),
    nameHindi: z.string().optional(),
    nameMarwari: z.string().optional(),
    descriptionEnglish: z.string().min(10, "English description is required"),
    descriptionHindi: z.string().optional(),
    descriptionMarwari: z.string().optional(),
    leadPerDay: z.string().optional(),
    tagLine: z.string().optional(),
});

export const EditSubscriptionModal = ({ isEditModalOpen, setIsEditModalOpen, subscription }) => {
    const { mutate: updateSubscription, isPending } = useUpdateSubs();

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: zodResolver(subscriptionEditSchema),
        defaultValues: {
            nameEnglish: "",
            nameHindi: "",
            nameMarwari: "",
            descriptionEnglish: "",
            descriptionHindi: "",
            descriptionMarwari: "",
            leadPerDay: "",
            tagLine: "",
        },
    });

    useEffect(() => {
        if (subscription) {
            reset({
                nameEnglish: subscription.name?.english || "",
                nameHindi: subscription.name?.hindi || "",
                nameMarwari: subscription.name?.marwari || "",
                descriptionEnglish: subscription.description?.english || "",
                descriptionHindi: subscription.description?.hindi || "",
                descriptionMarwari: subscription.description?.marwari || "",
                leadPerDay: subscription.leadPerDay || "",
                tagLine: subscription.tagLine || "",
            });
        }
    }, [subscription, reset]);

    const onSubmit = (data) => {
        const name = {};
        if (data.nameEnglish) name.english = data.nameEnglish;
        if (data.nameHindi)   name.hindi   = data.nameHindi;
        if (data.nameMarwari) name.marwari  = data.nameMarwari;

        const description = {};
        if (data.descriptionEnglish) description.english = data.descriptionEnglish;
        if (data.descriptionHindi)   description.hindi   = data.descriptionHindi;
        if (data.descriptionMarwari) description.marwari  = data.descriptionMarwari;

        const subscriptionData = {
            name,
            description,
            ...(data.leadPerDay && { leadPerDay: data.leadPerDay }),
            ...(data.tagLine    && { tagLine: data.tagLine }),
        };

        updateSubscription(
            { subscriptionId: subscription._id, subscriptionData },
            {
                onSuccess: () => {
                    reset();
                    setIsEditModalOpen(false);
                },
            }
        );
    };

    if (!isEditModalOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
            <div className="bg-white w-full max-w-4xl rounded-xl shadow-xl border border-gray-200 p-6 max-h-[90vh] overflow-y-auto">

                {/* Header */}
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-semibold text-gray-900">Edit Subscription Plan</h2>
                    <button onClick={() => setIsEditModalOpen(false)} className="text-gray-400 hover:text-gray-600">
                        <X size={22} />
                    </button>
                </div>

                {/* Form */}
                <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">

                    {/* Names Section */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div>
                            <label className="block text-sm text-gray-600 mb-1">Plan Name (English) *</label>
                            <input
                                {...register("nameEnglish")}
                                className="w-full bg-white border border-gray-300 text-gray-900 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-400"
                                placeholder="Premium Plan"
                            />
                            {errors.nameEnglish && (
                                <p className="text-red-500 text-xs mt-1">{errors.nameEnglish.message}</p>
                            )}
                        </div>
                        <div>
                            <label className="block text-sm text-gray-600 mb-1">Plan Name (Hindi)</label>
                            <input
                                {...register("nameHindi")}
                                className="w-full bg-white border border-gray-300 text-gray-900 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-400"
                                placeholder="प्रीमियम योजना"
                            />
                        </div>
                        <div>
                            <label className="block text-sm text-gray-600 mb-1">Plan Name (Marwari)</label>
                            <input
                                {...register("nameMarwari")}
                                className="w-full bg-white border border-gray-300 text-gray-900 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-400"
                                placeholder="प्रीमियम योजना"
                            />
                        </div>
                    </div>

                    {/* Descriptions Section */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div>
                            <label className="block text-sm text-gray-600 mb-1">Description (English) *</label>
                            <textarea
                                {...register("descriptionEnglish")}
                                className="w-full bg-white border border-gray-300 text-gray-900 rounded-md px-3 py-2 h-20 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-400"
                                placeholder="Full access to all features"
                            />
                            {errors.descriptionEnglish && (
                                <p className="text-red-500 text-xs mt-1">{errors.descriptionEnglish.message}</p>
                            )}
                        </div>
                        <div>
                            <label className="block text-sm text-gray-600 mb-1">Description (Hindi)</label>
                            <textarea
                                {...register("descriptionHindi")}
                                className="w-full bg-white border border-gray-300 text-gray-900 rounded-md px-3 py-2 h-20 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-400"
                                placeholder="सभी सुविधाओं तक पूर्ण पहुंच"
                            />
                        </div>
                        <div>
                            <label className="block text-sm text-gray-600 mb-1">Description (Marwari)</label>
                            <textarea
                                {...register("descriptionMarwari")}
                                className="w-full bg-white border border-gray-300 text-gray-900 rounded-md px-3 py-2 h-20 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-400"
                                placeholder="सगळी सुविधा"
                            />
                        </div>
                    </div>

                    {/* Tagline & Lead Per Day Section */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm text-gray-600 mb-1">Tagline</label>
                            <input
                                {...register("tagLine")}
                                className="w-full bg-white border border-gray-300 text-gray-900 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-400"
                                placeholder="The best plan for growing businesses"
                            />
                        </div>
                        <div>
                            <label className="block text-sm text-gray-600 mb-1">Leads Per Day</label>
                            <input
                                {...register("leadPerDay")}
                                className="w-full bg-white border border-gray-300 text-gray-900 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-400"
                                placeholder="50"
                            />
                        </div>
                    </div>

                    {/* Buttons */}
                    <div className="flex justify-end gap-4 pt-4 border-t border-gray-200">
                        <button
                            type="button"
                            className="text-gray-500 hover:text-gray-700"
                            onClick={() => setIsEditModalOpen(false)}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={isPending}
                            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md disabled:opacity-60"
                        >
                            {isPending ? "Updating..." : "Update Subscription"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};